function cleanLaunchValue(value) {
  return String(value || "").trim();
}

export function readTemplateLaunchSelection(search) {
  const sourceSearch =
    typeof search === "string"
      ? search
      : typeof window !== "undefined"
        ? window.location.search
        : "";
  const params = new URLSearchParams(sourceSearch);
  return {
    moduleKey: cleanLaunchValue(params.get("moduleKey")),
    submoduleKey: cleanLaunchValue(params.get("submoduleKey")),
    moduleName: cleanLaunchValue(params.get("moduleName")),
    submoduleName: cleanLaunchValue(params.get("submoduleName")),
    scenarioName: cleanLaunchValue(params.get("scenarioName")),
  };
}

export function hasTemplateLaunchSelection(selection) {
  return Object.values(selection).some(Boolean);
}

function matchesLaunchValue(currentValue, expectedValues) {
  const normalizedCurrent = cleanLaunchValue(currentValue);
  return Boolean(
    normalizedCurrent &&
    expectedValues.some((value) => cleanLaunchValue(value) === normalizedCurrent),
  );
}

function templateDomainForModule(moduleKey) {
  return moduleKey === "commercial-exchange" ? "commercial" : "risk";
}

function findTemplateLaunchModule(catalog, selection) {
  const modules = catalog?.modules || [];
  const moduleValues = [selection.moduleKey, selection.moduleName];
  const submoduleValues = [
    selection.submoduleKey,
    selection.submoduleName,
    selection.scenarioName,
    selection.moduleName,
  ];
  const moduleMatch = modules.find(
    (module) =>
      matchesLaunchValue(module.moduleKey, moduleValues) ||
      matchesLaunchValue(module.moduleName, moduleValues),
  );
  if (moduleMatch) return moduleMatch;
  return modules.find((module) =>
    (module.submodules || []).some(
      (submodule) =>
        matchesLaunchValue(submodule.submoduleKey, submoduleValues) ||
        matchesLaunchValue(submodule.submoduleName, submoduleValues),
    ),
  );
}

function findTemplateLaunchSubmodule(module, selection) {
  const values = [
    selection.submoduleKey,
    selection.submoduleName,
    selection.scenarioName,
    selection.moduleName,
  ];
  return (module?.submodules || []).find(
    (submodule) =>
      matchesLaunchValue(submodule.submoduleKey, values) ||
      matchesLaunchValue(submodule.submoduleName, values),
  );
}

export function resolveTemplateLaunchSelection(catalog, selection) {
  if (!hasTemplateLaunchSelection(selection)) return null;
  const matchedModule = findTemplateLaunchModule(catalog, selection);
  if (!matchedModule) return null;
  const matchedSubmodule = findTemplateLaunchSubmodule(matchedModule, selection);
  return {
    domain: templateDomainForModule(matchedModule.moduleKey),
    moduleKey: matchedModule.moduleKey,
    submoduleKey: matchedSubmodule?.submoduleKey || "all",
  };
}
